module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Italic-VariableFont_wght.117be28a.ttf";